import { Injectable } from "@angular/core";
import { BUTTON_ENUM, FILTER_ENUM } from "src/app/shared/model/shared.model";
import { SharedService } from "src/app/shared/service/shared.service";
import { FilterModel } from "../../../filter/model/filter.model";
import { IconModel } from "../../../icon/model/icon.model";
import { ActionColumn } from "../../components/action-column/model/actionColumn";
import { TextSubTextModel } from "../../components/text-subtext-column/model/text-subtext.model";
import { Column } from "../../model/column";
import { Table } from "../../model/table";
import { TableData } from "../../model/tableData";

@Injectable({providedIn:'root'})
export class TableUtilityService {
  constructor(private sharedService: SharedService) { }

  getDefaultFilterModel(filters): FilterModel {
    const defaultFilters = {} as FilterModel;
    defaultFilters.filterList = filters;
    defaultFilters.title = FILTER_ENUM.FILTERS;
    defaultFilters.resetField = true;
    defaultFilters.hasTitle = true;
    defaultFilters.maxDateRange = false;
    defaultFilters.button_confirm_label = BUTTON_ENUM.CONFIRM;
    defaultFilters.button_discard_label = BUTTON_ENUM.RESET;

    return defaultFilters;
  }

  getResponseToTable(columns: Array<Column>, values, totElements): Table {
    const table = {} as Table;
    table.columns = this.prepareToTranslation(columns);

    const response: TableData = {
      values,
      totElements,
      totPages: 0,
    };

    table.data = response;
    return table;
  }

  prepareToTranslation(columns: Array<Column> = []) {
    columns.forEach((column) => {
      column.label = this.sharedService.camelToUnderscore(column.label);
    });
    return columns;
  }

  get2RowIn1(
    firstRow: string,
    secondRow: string,
    hasClass?: boolean
  ): TextSubTextModel {
    return {
      text: firstRow,
      subText: secondRow,
      hasClass,
    };
  }

  getActionNavigationColumn(
    path: string,
    icon: IconModel
  ): Array<ActionColumn> {
    return [
      {
        path,
        icon,
      },
    ];
  }
}
